/*eslint-disable */
var $ = window.jQuery = require('jquery')
export default {
  name: 'interview-left-confernce-page',
  components: {},
  props: [],
  data () {
    return {
      hasGetFromRoute:''
    }
  },
  computed: {

  },
  mounted () {
    this.hasGetFromRoute = this.$route.hash
  },
  methods: {

  },
  beforeCreate: function() {
    $('body').addClass('dashboard')
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('dashboard')
    next();
  },
}